export default __webpack_public_path__ + "static/media/gnw-1.582c03ab.jpg";